import { Tooltip } from "@progress/kendo-react-tooltip";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import pdfIcon from "../../../../assets/images/pdfIcon.png";
import DiagnosisEducationPDF from "./diagnosis-education-pdf";
import { SettingsService } from "src/services/settingsService";
import { renderErrors } from "src/helper/error-message-helper";
import { Dialog } from "@progress/kendo-react-dialogs";
import noPlan from "../../../../assets/images/undraw_blank_canvas_re_2hwy 1.png";

const DiagnosisEducationViewer = ({ onClose, isDiagnosis }) => {
  const [htmlContent, setHtmlContent] = useState("");
  const [minDiagnoseName, setMinDiagnoseName] = useState("");
  const [isPrintPDF, setIsPrintPDF] = useState(false);
  const [clinicDetails, setClinicDetails] = useState([]);
  let xmlString = ``;
  const state = useSelector((states) => states);
  const { diagnosisEducation, medicationEducation } = state["ClientReducer"];
  const clientDetail = useSelector((state) => state.clientDetails);
  const primaryDx = useSelector((state) => state.PrimaryDX);
  let minRankNumber = Infinity;

  const currentInsurance = useSelector(
    (state) => state.currentInsuranceDetails
  );

  const handleError = (errorMessage) => {
    renderErrors(errorMessage);
  };

 const clinicId = useSelector((state) => state.loggedIn.clinicId);
  const selectedClientId = useSelector((state) => state.selectedClientId);

  useEffect(() => {
    if (diagnosisEducation && isDiagnosis) {
      xmlString = diagnosisEducation;
      handleConvert();
    }
    else {
      xmlString = medicationEducation;
      handleConvert();
    }
  }, [diagnosisEducation, medicationEducation]);

  const handlePrintPDF = () => {
    setIsPrintPDF(true);
  };

    useEffect(() => {
      getClinicDetails();
    }, [selectedClientId]);

    const getClinicDetails = async () => {
    //   setLoading(true);
      const clinicInfoResponse = await SettingsService.getClinicDetails(clinicId);
      if (
        clinicInfoResponse &&
        clinicInfoResponse != null &&
        clinicInfoResponse.resultData !== null
      ) {
        // setLoading(false);
        setClinicDetails(clinicInfoResponse?.resultData);
      } else {
        // setLoading(false);
      }
    };

    useEffect(() => {
      if(primaryDx) {
        primaryDx?.forEach(({ rankNumber, icd10 }) => {
          if (rankNumber < minRankNumber) {
            minRankNumber = rankNumber;
            setMinDiagnoseName(icd10);
          }
        });
      }
    }, [primaryDx]);

    const handleConvert = () => {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(xmlString, "text/xml");
    
      const ns = "http://www.w3.org/2005/Atom";
      const entries = xmlDoc.getElementsByTagNameNS(ns, "entry");
    
      const contentHtml = Array.from(entries).map((entry) => {
        const titleNode = entry.getElementsByTagNameNS(ns, "title")[0];
        const summaryNode = entry.getElementsByTagNameNS(ns, "summary")[0];
    
        const title = titleNode?.textContent || "No Title";
        const summaryEncoded = summaryNode?.textContent || "";
    
        const div = document.createElement("div");
        div.innerHTML = summaryEncoded;
    
        const links = div.querySelectorAll("a");
        links.forEach((link) => {
          link.setAttribute("target", "_blank");
          link.setAttribute("rel", "noopener noreferrer"); // security best practice
        });
    
        const summary = div.innerHTML;
    
        return `<h3>${title}</h3>${summary}`;
      });
    
      setHtmlContent(contentHtml);
    };
    

    return (
      <Dialog
        onClose={onClose}
        title={isDiagnosis ? 'Diagnosis Education PDF' : 'Medication Education PDF'}
        className="pagination-row-cus blue_theme"
        width={"70%"}
        height={"70%"}
      >
        {htmlContent?.length > 0 ? (
          <div className="pl-4">
            <div className="right-align-docs row">
              <Tooltip anchorElement="target" position="top">
                <button
                  disabled={isPrintPDF}
                  className="p-2 btn btnIcon cancelBtn"
                  onClick={handlePrintPDF}
                >
                  {isPrintPDF ? (
                    <div
                      className="spinner-border text-dark spinner-sm"
                      role="status"
                    >
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : (
                    <img src={pdfIcon} alt="pdf" title="Print" />
                  )}
                </button>
              </Tooltip>
            </div>
    
            {!isPrintPDF ? (
              <div className="row">
                <div
                  className="targetH3"
                  dangerouslySetInnerHTML={{ __html: htmlContent }}
                />
              </div>
            ) : (
              <DiagnosisEducationPDF
                setIsPrintPDF={setIsPrintPDF}
                isPrintPDF={isPrintPDF}
                onError={handleError}
                clientDetail={clientDetail}
                currentInsurance={currentInsurance}
                minDiagnoseName={minDiagnoseName}
                clinicDetails={clinicDetails}
                htmlContentPdf={htmlContent}
                isDiagnosis={isDiagnosis}
              />
            )}
          </div>
        ) : (
          <div className="message-not-found mt-3 text-center d-block bg-transparent">
            <img src={noPlan} alt="no plan" />
            <h6 className="mt-3 fw-bold">No Record Available</h6>
          </div>
        )}
      </Dialog>
    );
    
};

export default DiagnosisEducationViewer;
